import { Box } from '@mui/material';
import { Search } from 'lucide-react';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../../modules/translation/TranslationContext';
import ResultRowBase from './ResultRow/ResultRowBase';
import Thumbnail from './Thumbnail';

interface ResultsNavFooterProps {
  term: string;
  entityLabel: string;
  onNavigate: () => void;
}

function ResultsNavFooter({ term, entityLabel, onNavigate }: ResultsNavFooterProps) {
  const { translate } = useTranslation();

  return (
    <Box sx={(theme) => ({ flexShrink: 0, borderTop: `0.5px solid ${theme.palette.divider}` })}>
      <ResultRowBase
        testId="global-search-nav-footer"
        onClick={onNavigate}
        leading={<Thumbnail alt="" fallbackIcon={Search} />}
        title={translate(LangEnum.GLOBAL_SEARCH_IN_ENTITY, { term, entity: entityLabel })}
      />
    </Box>
  );
}

export default ResultsNavFooter;
